module.exports = __webpack_public_path__ + "img/question-mark.679ce72f.svg";